import { render, staticRenderFns } from "./TransportRequest.vue?vue&type=template&id=546bb9a9"
import script from "./TransportRequest.vue?vue&type=script&lang=js"
export * from "./TransportRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports